import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { InfoIcon, PathwayIconWrapperButton } from "../StyledComponents/PathwayIcons";
import stringUtils from "../../_services/string-utils";

export const ControlledPathwayTooltip = (props) => {
    return (
        <WrapperButtonForToolTip
            id={props.id}
            data-cy={stringUtils.camelCaseToLowerCaseIdentifier(props.id)}
            style={{ verticalAlign: "top", width: "25px" }}
        >
            {props.icon ? (
                props.icon
            ) : (
                <InfoIcon $primary={props.primaryColor} $size={props.iconSize || "var(--iconSize-s)"} />
            )}
            <Tooltip
                placement={props.placement || "right"}
                style={{
                    backgroundColor: "rgb(240, 243, 245)",
                    color: "black",
                    maxWidth: props.maxWidth || "350px",
                }}
                autohide={false}
                isOpen={props.isOpen}
                target={props.id}
                toggle={() => props.toggleTooltip(props.id)}
                dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
            >
                {props.children}
            </Tooltip>
        </WrapperButtonForToolTip>
    );
};

ControlledPathwayTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    placement: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    toggleTooltip: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    primaryColor: PropTypes.bool,
    maxWidth: PropTypes.string,
    iconSize: PropTypes.string,
    dangerouslySetInnerHTML: PropTypes.object,
};

export const PathwayTooltip = (props) => {
    const [showTooltip, toggleTooltip] = useState(false);

    return (
        <ControlledPathwayTooltip
            id={props.id}
            isOpen={showTooltip}
            toggleTooltip={() => {
                if (props.closingDelay && showTooltip) {
                    setTimeout(() => {
                        toggleTooltip(!showTooltip);
                    }, props.closingDelay);
                } else {
                    toggleTooltip(!showTooltip);
                }
            }}
            placement={props.placement}
            icon={props.icon}
            iconSize={props.iconSize}
            primaryColor={props.primaryColor}
            maxWidth={props.maxWidth}
            dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
        >
            {props.children}
        </ControlledPathwayTooltip>
    );
};

PathwayTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    placement: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    primaryColor: PropTypes.bool,
    maxWidth: PropTypes.string,
    iconSize: PropTypes.string,
    icon: PropTypes.element,
    dangerouslySetInnerHTML: PropTypes.object,
    closingDelay: PropTypes.number,
};

const WrapperButtonForToolTip = styled(PathwayIconWrapperButton)`
    ${(props) =>
        props.primaryColor &&
        css`
            color: #20a8d8;
        `};
`;
